import c0 from './add_credential_controller';
import c1 from './code_editor_controller';
import c2 from './comment_editor_controller';
import c3 from './confetti_controller';
import c4 from './credential_authenticator_controller';
import c5 from './form_controller';
import c6 from './input_disable_controller';
import c7 from './list_filter_controller';
import c8 from './prefill_rich_text_controller';
import c9 from './prompt_preview_controller';
export const definitions = [
	{identifier: 'add-credential', controllerConstructor: c0},
	{identifier: 'code-editor', controllerConstructor: c1},
	{identifier: 'comment-editor', controllerConstructor: c2},
	{identifier: 'confetti', controllerConstructor: c3},
	{identifier: 'credential-authenticator', controllerConstructor: c4},
	{identifier: 'form', controllerConstructor: c5},
	{identifier: 'input-disable', controllerConstructor: c6},
	{identifier: 'list-filter', controllerConstructor: c7},
	{identifier: 'prefill-rich-text', controllerConstructor: c8},
	{identifier: 'prompt-preview', controllerConstructor: c9},
];
